import React from 'react';

export const Arrow = ({ text, className }) => {
  return (
    <div className={className}>
      <i className={`fas fa-angle-${text}`} />
    </div>
  );
};
